import {
  CompactChoiceRow,
  CompactRankSelect,
  DESCRIPTION_INPUT_CLASS,
  FieldLabel,
  FormSection,
  SegmentedChoice,
  ZapPublicationChoice,
} from "../../../../../components/propertyDescription/descriptionUi";
import { HOUSING_PROGRAM_CHOICES } from "../../../../../utils/housingProgram";
import { FLOOR_TYPES, PROPERTY_TYPES } from "../constants";
import { PROPERTY_TYPE_ICONS } from "../propertyTypeIcons";

type Props = {
  propertyTypeId: number;
  floorType: string;
  housingProgram: string;
  rank: number | undefined;
  zapPublicationType: string;
  yearBuilt: string;
  virtualTourUrl: string;
  onChange: (field: string, value: unknown) => void;
};

export default function ClassificationSection({
  propertyTypeId,
  floorType,
  housingProgram,
  rank,
  zapPublicationType,
  yearBuilt,
  virtualTourUrl,
  onChange,
}: Props) {
  return (
    <FormSection title="Identificação do imóvel">
      <div className="grid grid-cols-1 gap-x-8 gap-y-5 md:grid-cols-[minmax(0,1.75fr)_minmax(0,1fr)]">
        <div className="min-w-0">
          <FieldLabel>Tipo do imóvel</FieldLabel>
          <CompactChoiceRow
            value={propertyTypeId}
            onChange={(value) => onChange("property_type_id", value)}
            options={PROPERTY_TYPES.map((type) => ({
              value: type.value,
              label: type.label,
              icon: PROPERTY_TYPE_ICONS[type.value as keyof typeof PROPERTY_TYPE_ICONS],
            }))}
          />
        </div>
        <div className="min-w-0">
          <FieldLabel>Enquadramento habitacional</FieldLabel>
          <SegmentedChoice
            value={housingProgram}
            onChange={(value) => onChange("housing_program", value)}
            options={HOUSING_PROGRAM_CHOICES.map((item) => ({
              value: item.value,
              label: item.label,
            }))}
          />
        </div>
      </div>
      <div className="mt-4 grid grid-cols-1 gap-x-8 gap-y-5 sm:grid-cols-2">
        <div className="min-w-0">
          <FieldLabel>Tipo de andar</FieldLabel>
          <SegmentedChoice
            value={floorType}
            onChange={(value) => onChange("floor_type", value)}
            options={FLOOR_TYPES.map((item) => ({
              value: item.value,
              label: item.label,
            }))}
          />
        </div>
        <div className="min-w-0">
          <FieldLabel>Nível de destaque</FieldLabel>
          <CompactRankSelect
            value={rank}
            onChange={(ranking) => onChange("rank", ranking)}
          />
        </div>
        <div className="min-w-0">
          <FieldLabel>Publicação no ZAP</FieldLabel>
          <ZapPublicationChoice
            value={zapPublicationType}
            onChange={(value) => onChange("zap_publication_type", value)}
          />
        </div>
        <div className="min-w-0">
          <FieldLabel>Ano de construção</FieldLabel>
          <input
            type="number"
            value={yearBuilt}
            onChange={(event) => onChange("year_built", event.target.value)}
            className={DESCRIPTION_INPUT_CLASS}
          />
        </div>
        <div className="min-w-0">
          <FieldLabel>Tour virtual (Banib)</FieldLabel>
          <input
            type="text"
            value={virtualTourUrl}
            onChange={(event) => onChange("virtual_tour_url", event.target.value)}
            placeholder="Link gerado pelo Banib"
            className={DESCRIPTION_INPUT_CLASS}
          />
        </div>
      </div>
    </FormSection>
  );
}
